/* Copyright (C) ZibatRan, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Zibatran development team, Dec 2020
 */
import { openNotificationWithIcon, logoutUser } from "../Helper";
const axios = require("axios");
import { saveAs } from "file-saver";

export async function postData(url, body) {
  return axios
    .post(url, body)
    .then(function (response) {
      if (response.data) {
        return response.data;
      } else {
        return false;
      }
    })
    .catch(function (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors.length > 0
      ) {
        openNotificationWithIcon("error", "خطا", error.response.data.errors[0].permission ? error.response.data.errors[0].permission : error.response.data.errors[0]);
      }
      if (
        error &&
        error.response &&
        error.response.status &&
        error.response.status === 403 &&
        error.response.data.errors[0].permission
      ) {
        return openNotificationWithIcon("error", "خطا", "شما به این صفحه دسترسی ندارید!");
      } else if (error &&
        error.response &&
        error.response.status &&
        error.response.status === 403) {
        logoutUser();
      }
      return false;
    });
}

export async function protectedPostData(
  url,
  body,
  showError = true,
  isJson = false
) {
  let headers = {
    AUTHORIZATION: `Bearer ${localStorage.getItem("zibatran-user-data") &&
      JSON.parse(localStorage.getItem("zibatran-user-data")).hasOwnProperty(
        "access_token"
      )
      ? JSON.parse(localStorage.getItem("zibatran-user-data")).access_token
      : ""
      }`,
  };
  if (isJson) {
    headers["Content-Type"] = "application/json";
  }
  return axios
    .post(url, body, {
      headers: headers,
    })
    .then(function (response) {
      if (response.data) {
        return response.data;
      } else {
        return false;
      }
    })
    .catch(function (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors.length > 0
      ) {
        openNotificationWithIcon("error", "خطا", error.response.data.errors[0].permission ? error.response.data.errors[0].permission : error.response.data.errors[0]);
      }
      if (
        error &&
        error.response &&
        error.response.status &&
        error.response.status === 403 &&
        error.response.data.errors[0].permission
      ) {
        return openNotificationWithIcon("error", "خطا", "شما به این صفحه دسترسی ندارید!");
      } else if (error &&
        error.response &&
        error.response.status &&
        error.response.status === 403) {
        logoutUser();
      }
      return false;
    });
}

export async function DownloadFile(url, payload, fileName, fileFormat, setLoading) {
  setLoading(true)
  try {
    const response = await axios.post(url, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("zibatran-user-data") &&
          JSON.parse(localStorage.getItem("zibatran-user-data")).hasOwnProperty(
            "access_token"
          )
          ? JSON.parse(localStorage.getItem("zibatran-user-data"))
            .access_token
          : ""
          }`,
      },
      responseType: "blob",
    });

    const file = new Blob([response.data], {
      type:
        fileFormat === "xlsx"
          ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          : fileFormat === "csv" && "text/csv",
    });
    saveAs(file, `${fileName}.${fileFormat}`);
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false)
  }
}
export async function DownloadFileGet(url, fileName, fileFormat, setLoading) {
  setLoading(true)
  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("zibatran-user-data") &&
          JSON.parse(localStorage.getItem("zibatran-user-data")).hasOwnProperty(
            "access_token"
          )
          ? JSON.parse(localStorage.getItem("zibatran-user-data"))
            .access_token
          : ""
          }`,
      },
      responseType: "blob",
    });

    const file = new Blob([response.data], {
      type:
        fileFormat === "xlsx"
          ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          : fileFormat === "csv" && "text/csv",
    });
    saveAs(file, `${fileName}.${fileFormat}`);
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false)
  }
}

export async function getData(url, showError = false) {
  return axios
    .get(url, {
      headers: {
        AUTHORIZATION: `Bearer ${localStorage.getItem("zibatran-user-data") &&
          JSON.parse(localStorage.getItem("zibatran-user-data")).hasOwnProperty(
            "access_token"
          )
          ? JSON.parse(localStorage.getItem("zibatran-user-data"))
            .access_token
          : ""
          }`,
      },
    })
    .then(function (response) {
      if (response.data) {
        return response.data;
      } else {
        return false;
      }
    })
    .catch(function (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors.length > 0
      ) {
        openNotificationWithIcon("error", "خطا", error.response.data.errors[0].permission ? error.response.data.errors[0].permission : error.response.data.errors[0]);
      }
      if (
        error &&
        error.response &&
        error.response.status &&
        error.response.status === 403 &&
        error.response.data.errors[0].permission
      ) {
        return openNotificationWithIcon("error", "خطا", "شما به این صفحه دسترسی ندارید!");
      } else if (error &&
        error.response &&
        error.response.status &&
        error.response.status === 403) {
        logoutUser();
      }
      return false;
    });
}

export async function delData(url) {
  let headers = {
    AUTHORIZATION: `Bearer ${localStorage.getItem("zibatran-user-data") &&
      JSON.parse(localStorage.getItem("zibatran-user-data")).hasOwnProperty(
        "access_token"
      )
      ? JSON.parse(localStorage.getItem("zibatran-user-data")).access_token
      : ""
      }`,
  };
  return await axios({
    url: url,
    method: "delete",
    headers: headers,
  });
}

export async function putData(url, showError = false) {
  let headers = {
    AUTHORIZATION: `Bearer ${localStorage.getItem("zibatran-user-data") &&
      JSON.parse(localStorage.getItem("zibatran-user-data")).hasOwnProperty(
        "access_token"
      )
      ? JSON.parse(localStorage.getItem("zibatran-user-data")).access_token
      : ""
      }`,
  };
  return await axios({
    url: url,
    method: "put",
    headers: headers,
  })
    .then(function (response) {
      if (response.data) {
        return response.data;
      } else {
        return false;
      }
    })
    .catch(function (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors.length > 0 &&
        showError
      ) {
        openNotificationWithIcon("error", "خطا", error.response.data.errors[0]);
      }
      return false;
    });
}
